import {
  UseInCommerceRequestClassDecision,
  UseInCommerceRequestType,
} from '@/utils/use-in-commerce-request/constants'

import {UseInCommerceRequestPriceConfig} from './types'

export const PRICE_CONFIGS = {
  SOU: {
    SPECIMEN: {basic: 'sou-basic', extra: 'sou-extra-class'},
    EXTENSION: {basic: 'sou-extension-basic', extra: 'sou-extension-extra-class', isFlatFee: true},
    DIVIDE: 'sou-divide',
    CLASS_DELETE: 'sou-post-noa-class-delete',
  },
  DOU: {
    SPECIMEN: {basic: 'dou-section-8-basic', extra: 'dou-section-8-extra-class'},
    GRACE_PERIOD_SURCHARGE: {
      basic: 'dou-section-8-grace-period-surcharge-basic',
    },
  },
  RENEWAL: {
    SPECIMEN: {basic: 'renewal-section-8-9-basic', extra: 'renewal-section-8-9-extra-class'},
    GRACE_PERIOD_SURCHARGE: {
      basic: 'renewal-section-8-9-grace-period-surcharge-basic',
    },
  },
} as const

export const useInCommerceRequestTypePriceMapper: Record<
  UseInCommerceRequestType,
  Record<UseInCommerceRequestClassDecision, UseInCommerceRequestPriceConfig | null>
> = {
  [UseInCommerceRequestType.statementOfUse]: {
    [UseInCommerceRequestClassDecision.specimen]: PRICE_CONFIGS.SOU.SPECIMEN,
    [UseInCommerceRequestClassDecision.extension]: PRICE_CONFIGS.SOU.EXTENSION,
    [UseInCommerceRequestClassDecision.abandon]: null,
  },
  [UseInCommerceRequestType.declarationOfUse]: {
    [UseInCommerceRequestClassDecision.specimen]: PRICE_CONFIGS.DOU.SPECIMEN,
    [UseInCommerceRequestClassDecision.extension]: null,
    [UseInCommerceRequestClassDecision.abandon]: null,
  },
  [UseInCommerceRequestType.renewal]: {
    [UseInCommerceRequestClassDecision.specimen]: PRICE_CONFIGS.RENEWAL.SPECIMEN,
    [UseInCommerceRequestClassDecision.extension]: null,
    [UseInCommerceRequestClassDecision.abandon]: null,
  },
}

export enum UseInCommerceRequestServiceItemTitleKey {
  statementOfUse = 'statement-of-use',
  declarationOfUse = 'declaration-of-use',
  renewal = 'renewal',
  extension = 'extension',
  abandon = 'abandon',
  divide = 'divide',
}
